
import { MicroApp, CSSC, DefineConfig, Created } from './test-data.js'
import { httpGetCanGetCoupons, httpLayout } from '@/api/market-research/index.js'
const defineData = new Created()
const Cssc = new DefineConfig({ ...CSSC, name: 'CsscTest' })
export default {
  mixins: [defineData],
  ...Cssc,
  render() {
    return (
      <div
        class={{ 'set-micro': true, isPC: !this.isMobile }}
        draggable
        onDragend={this.onDragend}
        data-ismobile={this.isMobile}
      >
        {this.list?.map((v, i) => (
          <CommonButton
            title={v.id}
            key={i}
            onClick={() => this.click(v)}
            type={this.isMobile ? 'text' : 'default'}
            class={{ active: v.active || false }}
          >
            {v.label}
          </CommonButton>
        ))}
      </div>
    )
  },
}
